import {
  Collapsible,
  EmptyInput,
  InputGroup,
  InputGroupBreak,
  InputRow,
  ModelNewNumericInput,
  RadioYesNoInput,
} from '@equifinance/shared';
import { useState } from 'react';
import { toNumber } from '@equifinance/shared/utils';
import { LoanDetails, useAccountContext } from '../../../../contexts';

export default function Fees({
  loanDetails,
}: {
  loanDetails: LoanDetails;
}) {
  const { creditSearchCompleted } = useAccountContext();

  const [showBrokerFeeError, setShowBrokerFeeError] = useState<boolean>(false);
  const [showAdviceFeeError, setShowAdviceFeeError] = useState<boolean>(false);
  const [showValuationFeeError, setShowValuationFeeError] = useState<boolean>(false);
  const [showLenderFeeError, setShowLenderFeeError] = useState<boolean>(false);

  return (
    <Collapsible
      id="fees"
      title="Fees"
      level={1}
      titleIcon={<></>}
    >
      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Broker fee"
            field="loanDetails.fees.BrokerFee.fee"
            prefix="£"
            isFixedDecimal
            required
            onBlur={() => setShowBrokerFeeError(true)}
            maxCharacters={10}
          />
          {toNumber(loanDetails?.fees?.BrokerFee?.fee) ? (
            <RadioYesNoInput
              label="Add to loan?"
              field="loanDetails.fees.BrokerFee.isAddToLoan"
              required
              hasError={showBrokerFeeError}
            />
          ) : (
            <EmptyInput />
          )}
        </InputRow>
      </InputGroup>

      <InputGroupBreak />

      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Advice fee"
            field="loanDetails.fees.AdviceFee.fee"
            prefix="£"
            onBlur={() => setShowAdviceFeeError(true)}
            isFixedDecimal
            maxCharacters={10}
          />
          {toNumber(loanDetails?.fees?.AdviceFee?.fee) ? (
            <RadioYesNoInput
              label="Add to loan?"
              field="loanDetails.fees.AdviceFee.isAddToLoan"
              required
              hasError={showAdviceFeeError}
            />
          ) : (
            <EmptyInput />
          )}

        </InputRow>
      </InputGroup>

      <InputGroupBreak />

      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Valuation fee"
            field="loanDetails.fees.ValuationFee.fee"
            prefix="£"
            isFixedDecimal
            onBlur={() => setShowValuationFeeError(true)}
            maxCharacters={10}
          />
          {toNumber(loanDetails?.fees?.ValuationFee?.fee) ? (
            <RadioYesNoInput
              label="Add to loan?"
              field="loanDetails.fees.ValuationFee.isAddToLoan"
              required
              hasError={showValuationFeeError}
            />
          ) : (
            <EmptyInput />
          )}
        </InputRow>
      </InputGroup>

      {creditSearchCompleted && (
        <>
          <InputGroupBreak />

          <InputGroup>
            <InputRow>
              <ModelNewNumericInput
                label="Lender fee"
                field="loanDetails.fees.LenderFee.fee"
                prefix="£"
                onBlur={() => setShowLenderFeeError(true)}
                isFixedDecimal
                required
                disabled
                maxCharacters={10}
                tooltip="Fee will be displayed once product selected"
              />
              {toNumber(loanDetails?.fees?.LenderFee?.fee) ? (
                <RadioYesNoInput
                  label="Add to loan?"
                  field="loanDetails.fees.LenderFee.isAddToLoan"
                  required
                  hasError={showLenderFeeError}
                />
              ) : (
                <EmptyInput />
              )}
            </InputRow>
          </InputGroup>
        </>
      )}

      {creditSearchCompleted && (
        <>
          <InputGroupBreak />

          <InputGroup>
            <InputRow>
              <ModelNewNumericInput
                label="Fees to be paid upfront"
                field="loanDetails.feesToBePaidUpfront"
                prefix="£"
                isFixedDecimal
                required
                disabled
              />
              <EmptyInput />
            </InputRow>
          </InputGroup>
        </>
      )}

    </Collapsible>
  );
}
